<ng-progress class="loading-bar"></ng-progress>
<router-outlet></router-outlet>
